module.exports = __webpack_public_path__ + "static/media/Happy.f99f2369.pdf";